
































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { GetBIReportList, DeleteBIReport,ExportReportBI } from "@/api/biReport";
import addOrEdit from "./addOrEdit.vue";
import design from "./design.vue";
import importData from "./importData.vue";

@Component({
  components: { addOrEdit, design,importData },
})
export default class extends AbpBase {
  queryString: string = "";
  loading = false;
  tableData: any = [];
  addOrEditShow = false;
  designShow = false;
  designData: any = {};
  columns: any = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: "报表名称",
      key: "reportName",
    },
    {
      title: "操作",
      width: 160,
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginRight: "10px",
                marginBottom: "5px",
                marginTop: "5px",
              },
              on: {
                click: () => {
                  this.del(p.row);
                },
              },
            },
            "删除"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "10px",
                marginBottom: "5px",
                marginTop: "5px",
              },
              on: {
                click: () => {
                  this.design(p.row);
                },
              },
            },
            "设计"
          ),
        ]);
      },
    },
  ];

  async getData() {
    this.loading = true;
    let res = await GetBIReportList({ queryString: this.queryString });
    this.tableData = res.objects;
    this.loading = false;
  }

  add() {
    this.addOrEditShow = true;
  }

  design(row: any) {
    this.designData = {
      report: row,
    };
    this.designShow = true;
  }

  async del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除此报表吗？",
      onOk: async () => {
        await DeleteBIReport({ reportNo: row.reportNo });
        this.getData();
      },
    });
  }

  created() {
    this.getData();
  }
  async exportData() {
    let filterCheck = (this.$refs.tabList as any).getSelection();
    if (filterCheck.length == 0) {
      this.$Message.warning("请勾选要导出的BI报表数据");
      return false;
    }
    let payload = { reportNoList: filterCheck.map((x) => x.reportNo) };
    this.loading = true;
    let res = await ExportReportBI(payload);
    this.loading = false;
    if (res.status == 1) {
      window.open(`${XMLHTTP_BASEURL}/${res.objects}`);
    }
  }
  importShow=false;
  importData() {
    this.importShow = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/biReport/index.vue